<div class="hotels-map">
  <ng-container *ngIf="(loading$ | async); else amMap">
    <div class="hotels-map__map-loading"></div>
  </ng-container>
  <ng-template #amMap>
    <google-map #hotelsMap height="100%" width="100%" [center]="center" [options]="mapOptions"
      (mapClick)="resetCurrentMarker()">

      <map-marker #currentMarker="mapMarker" *ngFor="let marker of markers" [position]="marker.position" [title]="marker.title"
        [id]="marker.id" [options]="marker.options" (mapClick)="openInfo(currentMarker, marker)">
      </map-marker>
      <map-marker #poiMarker="mapMarker" *ngFor="let poi of poiMarkers" [position]="poi.position" [title]="poi.title" [id]="poi.id"
        [options]="poi.options" (mapClick)="openPoiInfo(poiMarker, poi)">
      </map-marker>
      <map-info-window [options]="infoWindowOptions" (closeclick)="closeHotelMapInfoWindow()">
        <ng-container *ngIf="markerInfo?.type === 'location'">
          <am-hotels-map-info-window [currency]="markerInfo.info?.currency" [data]="markerInfo.info"
            [query]="query$ | async" [brand]="brand">
          </am-hotels-map-info-window>
        </ng-container>

        <ng-container *ngIf="markerInfo?.type === 'poi'">
          <h6>{{ markerInfo.info }}</h6>
        </ng-container>
      </map-info-window>
    </google-map>
    <div class="hotels-map__close-map" (click)="closeMap()">
      <mb-icon class="icon-close" icon="close"></mb-icon>
    </div>
  </ng-template>
</div>